const applicationErrorCodes = {
    device: {
        notExists: 51002,
        alreadyRegistered: 51003,
    },
    payment: {
        existingActiveSubscription: 53001,
        paymentFailedAuthenticationRequired: 53003,
        paymentFailedExpiredCreditCard: 53005,
        paymentFailedInvalidCreditCard: 53004,
        paymentFailedUnknownReason: 53006,
        promoCodeNotFound: 53008,
        promoCodeExpired: 53015,
        promoCodeRedemptionLimitReached: 53016,
        promoCodeRestrictionNotMet: 53017,
        promoCodeAlreadyRedeemed: 53018,
        promoCodeNewCustomersOnly: 53019,
        emailAlreadyTaken: 53021,
    },
    rssSync: {
        rssSyncFailed: 55001,
    },
    producer: {
        administratorConflict: 58001,
        producerNameEmpty: 58002,
        userNotFound: 58003,
        emailAlreadyExists: 58005,
        insufficientAccountBalance: 59006,
        stripeConnectAccountNotExists: 59005,
        producerUserAccountNotExists: 59004,
        stripeConnectAccountNotEnabled: 59007,
        userIsAdministrator: 59008,
        duplicateUsersSelected: 59002,
        loadioAndProducerConflict: 58010,
        stripeConnectPayoutsNotEnabled: 59010,
    },
    loadio: {
        invalidCurrentPassword: 51206,
    },
    betaChannel: {
        userAlreadyInChannel: 4090064001,
        userNotExist: 4090064002,
    },
};

export default applicationErrorCodes;
